<template lang="pug">
  div.modal-bg(@click="closeModal")
      div.refresh-web-design(@click.stop)
          div
              p.mb-0 Webサイトのデザインを更新しますか？
              span#modal-close(@click="closeModal")
          div
              p.mb-3.ml-3.mt-2 更新は、{{image_mode?"１～2時間":"5分"}}程度で完了します。
              p.mb-3.ml-3.mr-3 Masterプラン以上の場合、更新前のWebサイトのデザインは5つを上限に自動で保存され、更新後も更新前のWebサイトのデザインを選択し、表示できます。
              p.mb-3.ml-3.mr-3 Masterプラン未満の場合、更新後は更新前のWebサイトのデザインは上書きされ、表示ができなくなります。
          div.d-flex.justify-content-between
              a.mb-2.btn-sm(style="cursor: pointer;" @click.prevent="refreshWebDesign") Webサイトのデザインを更新する
              a.mb-2.btn-sm(href="/users/plans") プラン変更はこちら
  </template>

  <script>
import axios from '../../plugins/axios';
export default {
    props: {
      token: {type: String, default: "" },
      image_mode: {type: Boolean, default: true },
    },
    methods: {
        closeModal() {
            this.$emit('close-modal'); // 親コンポーネントへイベントを通知
        },
        async refreshWebDesign() {
            this.$emit('close-modal');
            try {
              const response = await axios.post("/api/v1/heatmaps/refresh_web_design/" + this.token, 
              {})
              
              if (response.status >= 200 && response.status < 300) {
                this.$toasted.success(response.data.message)
                await sleep(10000)
                this.$toasted.clear()
              } else {
                this.is_active = originValue
                this.$toasted.error(response.data.message)
                await sleep(10000)
                this.$toasted.clear()
              }
            } catch (error) {
              this.is_active = originValue
              if(error.response){
                const dummyEvent = {
                  preventDefault: () => {}
                }
              } else {
                  this.$toasted.error(response.data.message)
                  await sleep(10000)
                  this.$toasted.clear()
              }
            }
          },
    },
}
</script>
<style lang="scss" scoped>
.refresh-web-design {
  position: fixed;
  top: 32px;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  z-index: 99999;
  border-radius: 4px;
  width: 500px;
}

.refresh-web-design div:first-child {
  border-bottom: solid 1px #000;
  padding: 8px 16px;
}

.refresh-web-design div:last-child {
  padding: 8px 16px;
}

.refresh-web-design div:last-child a {
  border: none;
  background-color: #28A745;
  color: white;
  border-radius: 4px;
  padding: 4px 16px;
  width: fit-content;
  margin: auto;
}
</style>
